/**
 * External links to the Momentshare mobile apps on the Apple App Store and
 * Google Play. Centralised so the footer block, pricing matrix, host-admin
 * callout, mobile banner, etc. all reference the same canonical URLs.
 *
 * The canonical URLs are intentionally stripped of any analytics tracking
 * parameters (e.g. utm_source) — track app installs through the App Store
 * Connect / Play Console attribution surfaces instead so we don't pollute
 * the URL space scattered across the site.
 */
export const APP_STORE_LINK = 'https://apps.apple.com/nl/app/momentshare/id6762079606'
export const APP_STORE_ID = '6762079606'
export const PLAY_STORE_LINK = 'https://play.google.com/store/apps/details?id=io.momentshare.momentshare_event_app'

// useState key: measured height of the fixed Android app-store banner (0 when hidden).
export const APP_STORE_BANNER_HEIGHT_STATE = 'app-store-banner-height'
